<template>
    <component :is="component" v-if="component" :pointData="pointData"/>
</template>

<script>
    export default {
        name: "PointWriteLink",
        mixins: [],
        components: {},
        provide() {
            return {}
        },
        props: {
            writeLayout: {},
            pointData: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },
        data() {
            return {
                component: null,
            }
        },
        created() {},
        mounted() {
            this.writeLoader()
        },
        beforeDestroy() {},
        destroyed() {},
        computed: {
            loader() {
                if (!this.writeLayout) {
                    return null
                }
                return () => import(`@/template/point/write/${this.writeLayout}`)
            },
        },
        methods: {
            writeLoader() {
                this.loader()
                    .then(() => {
                        this.component = () => this.loader()
                    })
                    .catch(() => {
                        this.component = () => import('@/template/point/write/PointWriteDefaultLayout')
                    })
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>
